module.exports = __webpack_public_path__ + "static/media/cancelled_failed.6881b46c.svg";